/**
 * Created by CCristi on 7/15/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoleVoter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _VoterInterface2 = require('./VoterInterface');

var _BaseVoter = require('./BaseVoter');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let RoleVoter = exports.RoleVoter = function (_VoterInterface) {
  _inherits(RoleVoter, _VoterInterface);

  /**
   * @param {Object} role
   */
  function RoleVoter(role) {
    _classCallCheck(this, RoleVoter);

    var _this = _possibleConstructorReturn(this, (RoleVoter.__proto__ || Object.getPrototypeOf(RoleVoter)).call(this));

    _this._role = role;
    return _this;
  }

  /**
   * @param {String} context
   * @returns {Boolean}
   */


  _createClass(RoleVoter, [{
    key: 'vote',
    value: function vote(context) {
      for (let voter of this._negativeVoters) {
        if (voter.vote(context)) {
          return false;
        }
      }

      for (let voter of this._positiveVoters) {
        if (voter.vote(context)) {
          return true;
        }
      }

      return false;
    }

    /**
     * @returns {String}
     */

  }, {
    key: '_positiveVoters',
    get: function get() {
      let statements = this._role.Policy.Statement;

      return statements.filter(s => s.Effect === _VoterInterface2.VoterInterface.ALLOW).reduce((voters, statement) => {
        return voters.concat(statement.Action.map(_BaseVoter.BaseVoter.createFromAction));
      }, []);
    }

    /**
     * @returns {String}
     */

  }, {
    key: '_negativeVoters',
    get: function get() {
      let statements = this._role.Policy.Statement;

      return statements.filter(s => s.Effect === _VoterInterface2.VoterInterface.DENY).reduce((voters, statement) => {
        return voters.concat(statement.Action.map(_BaseVoter.BaseVoter.createFromAction));
      }, []);
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'role',
    get: function get() {
      return this._role;
    }
  }]);

  return RoleVoter;
}(_VoterInterface2.VoterInterface);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Voter/RoleVoter.js
// module id = 453
// module chunks = 0